import { render, staticRenderFns } from "./mtcFormItem.vue?vue&type=template&id=34fc7294&"
import script from "./mtcFormItem.vue?vue&type=script&lang=js&"
export * from "./mtcFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports